import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Order } from '../models/order';

@Injectable({
  providedIn: 'root'
})

export class OrderService {
    constructor(private http: HttpClient) {

    }

    public createOrder(order: Order): Observable<Order> {
        return this.http.post<Order>(environment.apiEndpoint + `/api/order/create`, order).pipe(
            map(res => {
                return new Order(res);
            })
        );
    }

    public createOrderFree(order: Order): Observable<Order> {
      return this.http.post<Order>(environment.apiEndpoint + `/api/order/createFree`, order).pipe(
          map(res => {
              return new Order(res);
          })
      );
    }

    public getOrder(order_id:number): Observable<Order> {
        return this.http.get<Order>(environment.apiEndpoint + `/api/order/${order_id}`).pipe(
            map(res => {
                return new Order(res);
            })
        );
    }

    // comment

    public getOrders(): Observable<Order[]> {
        return this.http.get<Order[]>(environment.apiEndpoint + `/api/orders`).pipe(
            map(res => {
                let orders=[];
                res.forEach(order=>{
                    orders.push(new Order(order));
                })
                return orders;
            })
        );
    }

    public sendNotification(orderId:number):Observable<any>{
      return this.http.post(environment.apiEndpoint+'/api/order/notify', {orderId:orderId}).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }
}
